import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login/Login'
import Home from '@/components/Home/Home'
import Historico from '@/components/Historico/Historico'
import HistoricalLegacy from '@/components/HistoricalLegacy'
import Reportes from '@/components/Historico/Reportes'
import Presion from '@/components/Presion/Presion'
import PresionNormal from '@/components/Presion/PresionNormal'
import PresionRange from '@/components/Presion/PresionRange'
import Bitacora from '@/components/Bitacora/Bitacora'
import Campo from '@/components/Campo/Campo'
import Tendencias from '@/components/Direccion/Tendencias'
import General from '@/components/Direccion/General'
import Poll from '@/components/Reportes/Poll'
import Pressure from '@/components/Reportes/Pressure'
import PressureReport from '@/components/Reportes/PressureReport'
import ReportePoll from '@/components/Reportes/Reportepoll'
import ReportePresion from '@/components/Reportes/Presion'
import Volumetria from '@/components/Volumetria/Volumetria'
import Configuracion from '@/components/Configuracion/Configuracion'
import Salud from '@/components/Salud/Salud'
import Sitio from '@/components/Sitio/sitio'
import Unauthorized from '@/components/Unauthorized/Unauthorized'
import Line from '@/components/Charts/CustomLineChart'
import PasswordRecovery from '@/components/PasswordRecovery/PasswordRecovery'
import Test from '@/components/test'
import Gard from './gards'


Vue.use(Router)
Vue.use(Gard)

export default new Router({
  routes: [{
      path: '/',
      name: 'Login',
      component: Login      
    },
    {
      path: '/passwordrecovery',
      name: 'Recuperar contraseña',
      component: PasswordRecovery,
      beforeEnter: Gard.recoveryGard,
    },
    {
      path: '/linechart',
      name: 'Line',
      component: Line,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'Home',
      component: Home,
      beforeEnter: Gard.dashboardGard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/historico',
      name: 'Historico',
      component: Historico,
      beforeEnter: Gard.historicAlarmGard,
      meta: {
        requiresAuth: true
      }
    },
	{
		path: '/historico-legacy',
		name: 'Historico Legacy',
		component: HistoricalLegacy,
		beforeEnter: Gard.historicAlarmGard,
		meta: {
		  requiresAuth: true
		}
	  },
    {
      path: '/historico/:id',
      name: 'Historico',
      component: Historico,
      beforeEnter: Gard.historicDetailAlarmGard,
      meta: {
        requiresAuth: true
      }
    },    
    {
      path: '/historico/reportes',
      name: 'Reportes',
      component: Reportes,
      beforeEnter: Gard.historicReportGard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/presion',
      name: 'Presión',
      component: Presion,
      beforeEnter: Gard.presionGard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/presionrange',
      name: 'Presión por rango de tiempo',
      component: PresionRange,
      beforeEnter: Gard.presionGard,
      meta: {
        requiresAuth: true
      }
    },       
    {
      path: '/presionnormal',
      name: 'Presión normalizada',
      component: PresionNormal,
      beforeEnter: Gard.presionGard,
      meta: {
        requiresAuth: true
      }
    },    
    {
      path: '/bitacora',
      name: 'Bitacora',
      beforeEnter: Gard.binnacleGard,
      component: Bitacora,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/campo',
      name: 'Campo',
      component: Campo,
      beforeEnter: Gard.campGard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/direccion/tendencias',
      name: 'Tendencias',
      component: Tendencias,
      beforeEnter: Gard.dirTrendGard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/direccion/general',
      name: 'General',
      component: General,
      beforeEnter: Gard.dirGeneralGard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reporte/pressure',
      name: 'ReportePressure',
      component: Pressure,
      beforeEnter: Gard.reportPollGard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reporte/pressurereport',
      name: 'PressureReport',
      component: PressureReport,
      beforeEnter: Gard.reportPollGard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reporte/poll',
      name: 'Poll',
      component: Poll,
      beforeEnter: Gard.reportPollGard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reporte/Reportepoll',
      name: 'Reportepoll',
      component: ReportePoll,
      beforeEnter: Gard.reportTablePollGard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reporte/presion',
      name: 'ReportePresion',
      component: ReportePresion,      
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/volumetria',
      name: 'Volumetria',
      component: Volumetria,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracion',
      name: 'Configuracion',
      component: Configuracion,
      beforeEnter: Gard.monitorGard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/salud',
      name: 'Salud',
      component: Salud,
      beforeEnter: Gard.healthGard,
      meta: {
        requiresAuth: true
      }
    },  
    {
      path: '/sitio/:section/:site',
      name: 'Sitio',
      component: Sitio,
      props: true,
      beforeEnter: Gard.healthGard,
      meta: {
        requiresAuth: true
      }
    },        
    {
      path: '/test',
      name: 'test',
      component: Test,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/unauthorized',
      name: 'Nopage',
      component: Unauthorized,
    },
    {
      path: '*',
      component: Login
    }

  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/routes.js